export default {
  computed: {
    /**
      * Check if interface is being debugged
      */
    debug() {
      var urlParams = new URLSearchParams(window.location.search);
      let canDebug = false;
      if (urlParams.has('debug')) {
        canDebug = (urlParams.get('debug') == 'true');
      }
      return canDebug;
    }
  }
};
